$(document).ready(function() {
    $('main [href*="/products/"]').click(function (e) {

        if ($(this).data('component') !== undefined) {
            e.preventDefault();

            let productsObj = $(this).data('component');
            let location = $(this).attr('href');

            try {
                if(window.useGA4) {
                    window.dataLayer.push({
                        'event': 'select_item',
                        'ecommerce': {
                            'items': [productsObj]
                        },
                        'eventCallback': function () {
                            document.location = location;
                        }
                    });
                } else {
                    window.dataLayer.push({
                        'event': 'productClick',
                        'ecommerce': {
                            'click': {
                                'products': productsObj
                            }
                        },
                        'eventCallback': function () {
                            document.location = location;
                        }
                    });
                }

            }
            catch(err) {

                // If GTM is not loaded due to a add blocker
                // this will make sure the site still functions as expected.
                document.location = location;
            } finally {

                // If GTM is not loaded due to a add blocker
                // this will make sure the site still functions as expected.
                document.location = location;
            }
        }
    });
});
